import Box from "@mui/material/Box";

export default function EstimateGraph(props: { level: number }) {
  return (
    <Box>
      <img
        src={`/estimator-steps/${props.level}.svg`}
        alt={`step-${props.level}`}
      />
    </Box>
  );
}
